import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable radix */
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import { Grid, IconButton, MenuItem, Select, } from '@mui/material';
import { getMonth, getYear, setMonth, setYear } from 'date-fns';
import { styled } from '../../../../utils';
const IconContainerStyled = styled(Grid)(() => ({
    padding: '5px',
}));
const IconStyled = styled(IconButton)(() => ({
    padding: '10px',
    '&:hover': {
        background: 'none',
    },
}));
const generateYears = (relativeTo, count) => {
    const half = Math.floor(count / 2);
    return Array(count)
        .fill(0)
        .map((_y, i) => relativeTo.getFullYear() - half + i); // TODO: make part of the state
};
const Header = ({ date, setDate, nextDisabled, prevDisabled, locale, onClickNext, onClickPrevious, }) => {
    const handleMonthChange = (event) => {
        setDate(setMonth(date, Number.parseInt(event.target.value)));
    };
    const handleYearChange = (event) => {
        setDate(setYear(date, Number.parseInt(event.target.value)));
    };
    const months = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((i) => locale?.localize?.month(i)) ?? [];
    return (_jsxs(Grid, { container: true, justifyContent: "space-between", alignItems: "center", children: [_jsx(IconContainerStyled, { item: true, children: _jsx(IconStyled, { disabled: prevDisabled, onClick: onClickPrevious, size: "medium", children: _jsx(ChevronLeft, { color: prevDisabled ? 'disabled' : 'action' }) }) }), _jsx(Grid, { item: true, children: _jsx(Select, { value: getMonth(date), onChange: handleMonthChange, variant: "standard", MenuProps: { disablePortal: true }, children: months.map((month, idx) => (_jsx(MenuItem, { value: idx, children: month }, month))) }) }), _jsx(Grid, { item: true, children: _jsx(Select, { value: getYear(date), onChange: handleYearChange, variant: "standard", MenuProps: { disablePortal: true }, children: generateYears(date, 30).map((year) => (_jsx(MenuItem, { value: year, children: year }, year))) }) }), _jsx(IconContainerStyled, { item: true, children: _jsx(IconStyled, { disabled: nextDisabled, onClick: onClickNext, size: "medium", children: _jsx(ChevronRight, { color: nextDisabled ? 'disabled' : 'action' }) }) })] }));
};
export default Header;
